import React from 'react';
import {
  getPlatformSubscriberDisplay,
  subscriberStatusBadgeClass,
} from '../utils/platformSubscriberClient';

export default function PlatformSubscriberPlanBadge({ client, modoOscuro, compact = false }) {
  const display = getPlatformSubscriberDisplay(client);
  if (!display) return null;

  const planClass = modoOscuro
    ? 'bg-[#1F80FF]/20 text-[#5CA3FF]'
    : 'bg-[#1F80FF]/10 text-[#1F80FF]';
  const statusClass = subscriberStatusBadgeClass(display.statusKey, modoOscuro);

  if (compact) {
    return (
      <div className="flex flex-wrap items-center gap-1 mt-1">
        <span className={`inline-flex px-1.5 py-0.5 rounded text-[10px] font-semibold ${planClass}`}>
          {display.planLabel}
        </span>
        <span className={`inline-flex px-1.5 py-0.5 rounded text-[10px] font-semibold ${statusClass}`}>
          {display.statusLabel}
        </span>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1">
      <span className={`inline-flex w-fit px-2 py-0.5 rounded-md text-[11px] font-semibold ${planClass}`}>
        {display.planLabel}
        <span className="opacity-70 font-normal ml-1">· {display.cycle}</span>
      </span>
      <span className={`inline-flex w-fit px-2 py-0.5 rounded-md text-[10px] font-semibold uppercase tracking-wide ${statusClass}`}>
        {display.statusLabel}
      </span>
    </div>
  );
}
